import _ from 'lodash';
import getQueryOperatorExpressions from './getQueryOperatorExpressions.js';
import makeGetPathExpression from './makeGetPathExpression.js';

export default function getQueryExpression(criteria, options) {
  const operatorExpressions = getQueryOperatorExpressions(c => getQueryExpression(c, options));

  const pathExpressions = _.chain(criteria)
    .map(makeGetPathExpression(operatorExpressions, options))
    .flattenDeep()
    .compact()
    .value();

  if (pathExpressions.length === 0) return {};
  if (pathExpressions.length === 1) return pathExpressions[0];

  return { $and: pathExpressions };
}
